import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiClient } from '@/App';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function BankCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Bankkoppeling wordt afgerond...');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (error) {
      setStatus('error');
      setMessage(errorDescription || 'De bankkoppeling is afgebroken of mislukt.');
      return;
    }

    if (!code || !state) {
      setStatus('error');
      setMessage('Er ontbreken gegevens om de bankkoppeling af te ronden.');
      return;
    }

    const finishLink = async () => {
      try {
        const response = await apiClient.post('/banking/truelayer/exchange', { code, state });
        const imported = Number(response.data?.transactions_imported || 0);
        const updated = Number(response.data?.transactions_updated || 0);
        setStatus('success');
        setMessage('Je bankrekening is gekoppeld. Je gaat nu terug naar instellingen.');
        window.setTimeout(() => {
          navigate(`/settings?bank_connected=1&transactions_imported=${imported}&transactions_updated=${updated}`, { replace: true });
        }, 1200);
      } catch (requestError) {
        setStatus('error');
        setMessage(
          requestError.response?.data?.detail ||
            'Het afronden van de bankkoppeling is niet gelukt.',
        );
      }
    };

    finishLink();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-background px-4 py-12">
      <div className="mx-auto max-w-lg">
        <Card className="shadow-card">
          <CardHeader>
            <CardTitle className="font-heading">
              {status === 'success' ? 'Bank gekoppeld' : 'Bankkoppeling'}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">{message}</p>
            {status === 'error' && (
              <Button className="rounded-full" onClick={() => navigate('/settings', { replace: true })}>
                Terug naar instellingen
              </Button>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
